export = {
  techKind: {
    total_points: "Tổng điểm",
    service_points_success: "Ghi điểm khi giao cầu",
    service_points_rate: "Tỷ lệ ghi điểm khi giao cầu",
    receiver_points_success: "Ghi điểm khi nhận cầu",
    receiver_points_rate: "Tỷ lệ ghi điểm khi nhận cầu",
    comeback_to_win: "Lật kèo",
    service_errors: "Lỗi phát cầu",
    biggest_lead: "Cách biệt lớn nhất",
    max_points_in_a_row: "Dành điểm liên tục nhiều nhất",
  },
  percentKeys: ["service_points_rate", "receiver_points_rate"],
  showPreKeys: ["service_points_success", "receiver_points_success"],
};
